import { useQuery } from '@tanstack/react-query';
import { Button } from '../Button';
import { downloadSowDocument, listSowDocuments } from '../../lib/api';
import { fmt } from '../../lib/format';
import { SOW_TEMPLATE_LABELS as TEMPLATE_LABEL } from '../../lib/sow';

interface Props {
  opportunitySfId: string;
}

/** Every generated version for this opportunity — nothing is ever overwritten. */
export function VersionHistory({ opportunitySfId }: Props): JSX.Element {
  const { data: docs, isLoading } = useQuery({
    queryKey: ['sow-docs', opportunitySfId],
    queryFn: () => listSowDocuments(opportunitySfId),
  });

  return (
    <div className="card">
      <div className="card-hd">
        <span className="d-h3">Version history</span>
        <span style={{ fontSize: 12.5, color: 'var(--mute)' }}>Every generation is kept</span>
      </div>
      {isLoading ? (
        <div style={{ padding: 16, fontSize: 13, color: 'var(--mute)' }}>Loading…</div>
      ) : (docs ?? []).length === 0 ? (
        <div style={{ padding: 16, fontSize: 13, color: 'var(--mute)' }}>
          Nothing generated for this opportunity yet.
        </div>
      ) : (
        <table className="tbl gen">
          <thead>
            <tr>
              <th>Template</th>
              <th className="num">Version</th>
              <th>File</th>
              <th>Generated by</th>
              <th>At</th>
              <th style={{ width: 1 }} />
            </tr>
          </thead>
          <tbody>
            {(docs ?? []).map((d) => (
              <tr key={d.id}>
                <td><span className="pill">{TEMPLATE_LABEL[d.templateType] ?? d.templateType}</span></td>
                <td className="num d-tnum">V{d.version}</td>
                <td style={{ maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.fileName ?? '—'}</td>
                <td>{d.generatedByEmail ?? '—'}</td>
                <td className="d-tnum">{fmt.dateTime(d.createdAt)}</td>
                <td style={{ paddingRight: 12 }}>
                  <Button size="sm" variant="ghost" icon="download" onClick={() => downloadSowDocument(d.id)}>
                    .docx
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
